import { action, observable } from 'mobx';

export class UiState {
  defaultErrorAction = () => {};
  @observable public isReady: boolean = false;
  @observable public hasError: boolean = false;
  @observable public showOnboardingScreen: boolean = false;
  @observable
  public error = {
    title: '',
    message: '',
    actionLabel: '',
    action: this.defaultErrorAction,
    showEmptyStateImage: false,
  };

  @action
  public setReady(isReady: boolean): void {
    this.isReady = isReady;
  }

  @action
  public setError({
    title,
    message,
    actionLabel,
    action,
    showEmptyStateImage,
  }: {
    title: string;
    message: string;
    actionLabel?: string;
    action?: () => void;
    showEmptyStateImage?: boolean;
  }): void {
    this.hasError = true;
    this.error.title = title;
    this.error.message = message;
    this.error.actionLabel = actionLabel || '';
    this.error.action = action || this.defaultErrorAction;
    this.error.showEmptyStateImage = showEmptyStateImage || false;
  }

  @action
  public clearError(): void {
    this.hasError = false;
    this.error.title = '';
    this.error.message = '';
    this.error.actionLabel = '';
    this.error.action = this.defaultErrorAction;
    this.error.showEmptyStateImage = false;
  }

  @action
  public enableOnboardingScreen(): void {
    this.showOnboardingScreen = true;
  }

  @action
  public disableOnboardingScreen(): void {
    this.showOnboardingScreen = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/store/UiState.ts